import {
  BooleanField,
  CreateButton,
  Datagrid,
  List,
  TextField,
  TopToolbar,
} from 'react-admin';

const ListActions = () => (
  <TopToolbar>
    <CreateButton />
  </TopToolbar>
);

export function CountryList() {
  return (
    <List actions={<ListActions />} sort={{ field: 'name', order: 'ASC' }} perPage={50}>
      <Datagrid rowClick="edit">
        <TextField source="name" />
        <TextField source="iso_code" label="ISO" />
        <TextField source="slug" />
        <BooleanField source="is_active" label="Active" />
      </Datagrid>
    </List>
  );
}
